
import React from "react";
import { Loader2 } from "lucide-react";

const LoadingState = () => {
  return (
    <tr>
      <td colSpan={7} className="h-24 text-center">
        <div className="flex justify-center items-center">
          <Loader2 className="h-6 w-6 animate-spin mr-2" />
          <span>Meldingen laden...</span>
        </div>
      </td>
    </tr>
  );
};

export default LoadingState;
